(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["brands"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const paginationLinks = document.querySelectorAll('.brand-collections__page-link[href*="page="]');
    const brandCollectionsBlock = document.querySelector('.brand-collections-block');
    
    paginationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        if (brandCollectionsBlock) {
          setTimeout(() => {
            const offset = 100;
            const elementPosition = brandCollectionsBlock.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }, 100);
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
